import React from 'react'
import {
  getImgProps,
  LibraryPostArticleCard as LibraryPostArticleCardComponent,
} from '@superhi/design'

import { API } from 'src/api'
import { SUPERLIBRARY_URL } from 'src/config'

type ComponentProps = Omit<
  React.ComponentProps<typeof LibraryPostArticleCardComponent>,
  'type' | 'description' | 'image' | 'link'
>

type Props = ComponentProps &
  API.LibraryPostArticleCardComponent & {
    __typename: 'LibraryPostArticle'
    slug: string
    noDescription?: boolean
    imageLazy?: boolean
  }

const LibraryPostArticleCard: React.FC<React.PropsWithChildren<Props>> = ({
  slug,
  image,
  noDescription,
  description,
  imageLazy = false,
  ...props
}) => {
  const imageProps = React.useMemo(
    () => ({
      ...getImgProps(
        image.url,
        {
          small: 100,
          medium: 50,
          large: 33,
          xlarge: 33,
        },
        {
          fm: 'png8',
        },
      ),
      lazy: imageLazy,
      blurHash: image.blurhash,
    }),
    [image, imageLazy],
  )

  const href = `${SUPERLIBRARY_URL}/posts/${slug}`

  return (
    <LibraryPostArticleCardComponent
      {...props}
      headingLevel="3"
      link={{ href, isExternal: true }}
      image={imageProps}
      description={noDescription ? undefined : description}
    />
  )
}

export { default as FRAGMENT } from './fragments'
export default LibraryPostArticleCard
